import { render, staticRenderFns } from "./myPosts.vue?vue&type=template&id=00e6ea32&"
import script from "./myPosts.vue?vue&type=script&lang=js&"
export * from "./myPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports